import { createSelector } from 'reselect';

// Config
import { getActiveAddressBookModalTypeSelector } from '@redux/reducers/app/appSelector';
import { getConfirmedDeliveryAddressSelector } from '@redux/reducers/delivery/deliverySelector';
import { getShowAddressBookModalSelector } from '@redux/reducers/payment/paymentSelector';
import { getAddressBookSelector, getSelectedBillingAddressSelector } from '@redux/reducers/user/userSelector';
import { isSinglePageCheckoutEnabledFeatureActive } from '@redux/reducers/config/configSelector';

const getBillingAddressSelector = createSelector(
  [getSelectedBillingAddressSelector, getConfirmedDeliveryAddressSelector],
  (selectedBillingAddress, confirmedDeliveryAddress) => selectedBillingAddress || confirmedDeliveryAddress,
);

const cardholdersDetailsAddressBookState = createSelector(
  [
    getAddressBookSelector,
    getBillingAddressSelector,
    getShowAddressBookModalSelector,
    getActiveAddressBookModalTypeSelector,
    isSinglePageCheckoutEnabledFeatureActive,
  ],
  (addressBook, billingAddress, showAddressBookModal, activeAddressBookModal, singlePageCheckoutEnabled) => ({
    addressBook,
    activeAddressBookModal,
    billingAddress,
    showAddressBookModal,
    singlePageCheckoutEnabled,
  }),
);

export default cardholdersDetailsAddressBookState;
